import { AppIcons, AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';

import { Box, Chip, SxProps, Theme } from '@mui/material';

export type TypeChipProps = Readonly<{
  label: string;
  icon?: AppIcons;
  id?: string;
  onClick?: () => void;
}>;

export const TypeChip = ({ label, icon, id, onClick }: TypeChipProps) => {
  return (
    <Box sx={typeChipContainerSx}>
      <Chip
        id={id}
        label={label}
        variant="pill"
        size="lg"
        icon={icon ? <AppIcon iconName={icon} diameter="16px" color="Brand/500" /> : undefined}
        onClick={onClick}
        sx={[typeChipSx, ...(onClick ? [clickableChipSx] : [])] as SxProps<Theme>}
      />
    </Box>
  );
};

const clickableChipSx: SxProps<Theme> = ({ backrs }) => ({
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: backrs.colors['Brand/100'],
  },
});

const typeChipContainerSx: SxProps<Theme> = {
  width: 'fit-content',
  maxWidth: '100%',
};

const typeChipSx: SxProps<Theme> = ({ backrs }) => ({
  border: `1px solid ${backrs.colors['Brand/200']}`,
  backgroundColor: backrs.colors['Brand/50'],
  color: backrs.colors['Brand/700'],
  objectFit: 'contain',
  gap: backrs.spacing['spacing-sm'],
  maxWidth: '100%',
  '& .MuiChip-label': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});
